export default "//static.tradera.net/touchweb/static/output/images/push-wishlist-icon.098d1553.svg";